import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { TributacaoBuscarPorPadraoEmissaoCTe } from "src/services/Fiscal.Service";
import { TributacaoDto } from "../../Tributacao/Tributacao/Tributacao.Dto";
import { showToast } from "src/componentes";
import { CTeDto, getLocal, STORAGECTE_KEY, updateLocal } from "../CTe.Dto";
import { useDelayedLoading } from "src/hook/useDelayedLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

const CTeCadastroTributacaoView = () => {
  const { loading, start, stop } = useDelayedLoading(500);
  const [data, setData] = useState<TributacaoDto[] | undefined>([]);
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);
  const [tributacaoSelecionada, setTributacaoSelecionada] = useState<
    number | undefined
  >(cte?.tributacaoId ?? undefined);
  const selecionado = tributacaoSelecionada !== undefined;

  const navigate = useNavigate();

  const handleVoltar = () => {
    navigate("../percurso");
  };

  const handleSalvar = (id: number) => () => {
    setTributacaoSelecionada(id);
    updateLocal<CTeDto>(STORAGECTE_KEY, {
      tributacaoId: id,
    });
    handleProximo();
  };

  const handleProximo = () => {
    navigate("../remetente");
  };

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      start();
      await TributacaoBuscarPorPadraoEmissaoCTe()
        .then((response) => {
          if (response.data.success) {
            const list: TributacaoDto[] = response.data.data || [];
            setData(list);

            if (!cte?.tributacaoId && list.length > 0) {
              const defaultCTe = list.find((x) => x.padraoEmissaoCTe);
              const selectedId = defaultCTe
                ? defaultCTe.id
                : list.length === 1
                ? list[0].id
                : undefined;
              if (selectedId) {
                setTributacaoSelecionada(selectedId);
                updateLocal<CTeDto>(STORAGECTE_KEY, {
                  tributacaoId: selectedId,
                });
              }
            }
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({
            message: "Ocorreu erro ao buscar tributações",
            title: "Erro",
            variant: "Danger",
          });
        })
        .finally(() => {
          stop();
        });
    };
    Load();
    return () => {
      stop();
      controller.abort();
    };
  }, []);

  return (
    <>
      {!loading ? (
        <>
          <Row className="mt-3 mb-5">
            <Col xs={12}>
              <h5 className="mb-3 text-primary">Selecione a Regra de Tributação</h5>
              {data && data.length > 0 ? (
                <Table responsive striped hover>
                  <thead>
                    <tr>
                      <th></th>
                      <th className="col-6">Nome</th>
                      <th className="col-3">CFOP</th>
                      <th className="d-none d-sm-table-cell col-3">Operação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item) => {
                      const isSelected = tributacaoSelecionada === item.id;

                      return (
                        <tr
                          key={item.id}
                          onClick={handleSalvar(item.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            {isSelected && (
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="text-success"
                                style={{ fontSize: "0.6rem" }}
                              />
                            )}
                          </td>
                          <td className="col-6">{item.nome}</td>
                          <td className="col-3">
                            {item.cfop?.map((x) => x.cfop).join(" - ") ?? "-"}
                          </td>
                          <td className="d-none d-sm-table-cell col-3">
                            {item.tipoOperacao} - {item.tipoOperacaoDescricao}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <Form.Text>Sem Dados</Form.Text>
              )}
            </Col>
          </Row>
          <div className="fixed-bottom">
            <Container className="py-3">
              <Row>
                <Col xs={selecionado ? 6 : 12} className="d-grid">
                  <Button variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </Button>
                </Col>
                {selecionado && (
                  <Col xs={6} className="d-grid">
                    <Button variant="outline-primary" onClick={handleProximo}>
                      Próximo
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow" className="mt-3">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </>
  );
};

export default CTeCadastroTributacaoView;
